import * as React from 'react';
import { AuthState } from '../auth/auth.types';
import { AdminState } from './admin.types';
import CommonFeatures from '../commons/CommonFeatures';
import ReactTable from 'react-table';
import { Account } from '../account/Types';
import RaisedButton from 'material-ui/RaisedButton';
import { BusinessState } from 'src/business/business.types';

type TableData = {
  readonly id: number
  readonly firstName: string
  readonly lastName: string
  readonly email: string
  readonly unlock: JSX.Element
};

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly businessState: BusinessState
  readonly getLockedAccounts: () => Promise<Response>
  readonly unlockAccount: (id: number) => Promise<Response>
};

type States = {
  readonly lockedAccounts: Account[]
};

class LockedAccountComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      lockedAccounts: props.adminState.lockedAccounts 
    };
  }

  componentDidMount() {
    this.props.getLockedAccounts();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps) {
      this.setState({lockedAccounts: nextProps.adminState.lockedAccounts});
    }
  }

  // componentWillUnmount() {
    
  // }

  render() {
    return(
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="page-header-row row mt-2">
          <div className="col-auto">
            <h3>Locked Accounts</h3>
          </div>
        </div>
        {this.renderLockedAccountTable()}
      </CommonFeatures>
    );
  }

  private renderLockedAccountTable = (): JSX.Element => {
    return(
      <ReactTable
        data={this.state.lockedAccounts.map((a: Account) => this.createTableData(a))}
        columns={[
          {
            accessor: 'id',
            Header: 'ID',
            style: {textAlign: 'center'}
          },
          {                                                                                       
            accessor: 'firstName',
            Header: 'First Name',
            style: {textAlign: 'center'}
          },
          {
            accessor: 'lastName',
            Header: 'Last Name',
            style: {textAlign: 'center'}
          },
          {
            accessor: 'email',
            Header: 'Email',
            style: {textAlign: 'center'}
          },
          {
            accessor: 'unlock',
            Header: 'Unlock',
            style: {textAlign: 'center'}
          }
        ]}
        defaultPageSize={20}
        className="-striped -highlight"
        keyField={'receiptId'}
      />
    );
  }

  private createTableData = (a: Account): TableData => {
    return {
      id: a.id,
      firstName: a.firstName,
      lastName: a.lastName,
      email: a.email,
      unlock: this.renderUnlockButton(a.id)
    };
  }

  private renderUnlockButton = (id: number): JSX.Element => {
    return(
      <RaisedButton
        primary={true}
        label="Unlock"
        onClick={() => this.props.unlockAccount(id)}
      />
    );
  }
}

export default LockedAccountComponent;



// WEBPACK FOOTER //
// ./src/admin/LockedAccountComponent.tsx